import { Modal, Button, Form, Col, Row, Container, FormCheck  } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import '../../assets/Styles/CancelTripCSS/CancelTripCSS.css';
// import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from '../../utils/helpers/APICom';


const CancelTrip = (data) => {
  
  /////////////////////////////////////////////////////  CANCEL COMPONENT HOOKS ///////////////////////////////////////////////////////
  const cancelReasonRef = useRef();
  const cancelCommentRef = useRef();
  const chkReturnTripRef = useRef();
  const [isComponentLoading, setIsComponentLoading] = useState(true);
  const [TableHeaders, setTableHeaders] = useState(["Select","Confirmation#","Pickup Person","Trip Status", "Return Trip"]);
  const [tripsInfo, setTripsInfo] = useState({});
  const [TripSelection, setTripSelection] = useState([]);
  const [showTripTable, setShowTripTable] = useState(false);
  // const isInitialRenderEmptyDependancy = useRef(true); 
  // const isInitialRenderWithDependancy = useRef(true);

  // Fetching Cancel Reason for Dropdown
  const { CancelReasonData } = useSelector((store) => store.combinedata);
  const { loginData }  = useSelector((store) => store.login);

  //useState for CancelTrip Component
  const [cancelTripObj, setCancelTripObj] = useState({iSRATSPID:'', ServiceID:'',TripRequestStatus:'', iAssignedVehicleId:'-1',
  iScheduleID:'-1',AssignedDriverId:'-1',ConfirmationNo:'',PickupPerson:'', PZONE:'',IsReturnTrip:'false',TableSource: '', ServiceStatus: '',
  iSchDetailID: '-1', CancelTripConf: '', CancelTripPickPerson:''});

  //useState for Confirmation Modal
  const [confirmationModal, setConfirmationModal] = useState({btnOkText: 'Ok', btnCancelText:'Cancel', show: false, title: '', body: '', msgType:''});

  //Cancel Dialog Options & Alert Modal useStates
  const [cancelReasons, setCancelReasons] = useState([]);
  // const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showCancelAlert, setShowCancelAlert] = useState(false);
  const [cancelAlert, setCancelAlert] = useState({alertTitle: '', alertMsg:''});
  // const [forceCancel, setForceCancel] = useState(false);
  const [IsReturnTrip, setIsReturnTrip] = useState("false");
  const [showTripStatus, setShowTripStatus] = useState(false);
  const [chkReturnTripVisible, setchkReturnTripVisible] = useState(false);
  const [isReturnTripCheckBox, setIsReturnTripChecBox] = useState(false);


  // Cancel Trip Component Load
  useEffect(() => {
    try{
      if(data.GridRowData === null || data.GridRowData.length <= 0)
      {
        setCancelAlert({...cancelAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to cancel.'});
        setShowCancelAlert(true);
      } 
      else if(data.GridRowData.length > 1)
      {
        setTripsInfo(data.GridRowData);
        let tripListPos = [];
        let dict = {};
        for(let i = 0; i < data.GridRowData.length; i++)
        {
          dict = {};
          dict[data.GridRowData[i].ConfirmationNo] = 1;
          tripListPos.push(dict);
        }
        setTripSelection(tripListPos);
        setShowTripTable(true);
        setchkReturnTripVisible(false);
        // let gData = [];
        // let serviceIDList = "";
        
        // setCancelAlert({...cancelAlert, alertTitle: 'Cancel Trip Alert', alertMsg:'This feature is a work in progress.'});
        // setShowCancelAlert(true);
        // updateCancelTripComponentStateObjects("cancelTripObj", {...cancelTripObj, iSRATSPID:gData[0].iSRATSPID, ServiceID:gData.ServiceID,TripRequestStatus:gData.TripRequestStatus, PickupPerson:gData.PickupPerson,
        //   iAssignedVehicleId:(gData.iAssignedVehicleId === undefined || gData.iAssignedVehicleId === null)?'-1':gData.iAssignedVehicleId, iScheduleID:(gData.iScheduleID === undefined|| gData.iScheduleID === null)?'-1': gData.iScheduleID,
        //   AssignedDriverId:(gData.AssignedDriverId === undefined || gData.iAssignedVehicleId === null)?'-1':gData.AssignedDriverId,ConfirmationNo:gData.ConfirmationNo, 
        //   PZONE:gData.PZONE,TableSource: gData.TableSource, ServiceStatus: gData.ServiceStatus, iSchDetailID: (gData.iSchDetailID == undefined || gData.iAssignedVehicleId === null)?'-1':gData.iSchDetailID,
        //   CancelTripConf: gData.ConfirmationNo, CancelTripPickPerson : gData.PickupPerson});
        // setIsReturnTrip(((gData[0].IsReturnTrip === "")?"false":(gData[0].IsReturnTrip?"true":"false")));
      }
      else{
        const gData = data.GridRowData[0];
        updateCancelTripComponentStateObjects("cancelTripObj", {...cancelTripObj, iSRATSPID:String(gData.iSRATSPID), ServiceID:String(gData.ServiceID),
          TripRequestStatus:gData.TripRequestStatus, PickupPerson:gData.PickupPerson,
          iAssignedVehicleId:(gData.iAssignedVehicleId === undefined || gData.iAssignedVehicleId === null)?'-1':String(gData.iAssignedVehicleId), 
          iScheduleID:(gData.iScheduleID === undefined|| gData.iScheduleID === null)?'-1': String(gData.iScheduleID),
          AssignedDriverId:(gData.AssignedDriverId === undefined || gData.AssignedDriverId === null)?'-1':String(gData.AssignedDriverId),ConfirmationNo:gData.ConfirmationNo, 
          PZONE:gData.PZONE,TableSource: gData.TableSource, ServiceStatus: gData.ServiceStatus, 
          iSchDetailID: (gData.iSchDetailID == undefined || gData.iSchDetailID === null)?'-1':gData.iSchDetailID,
          CancelTripConf: gData.ConfirmationNo, CancelTripPickPerson : gData.PickupPerson});
        setIsReturnTrip(((String(gData.IsReturnTrip).toLowerCase() === "")?false:(String(gData.IsReturnTrip).toLowerCase() === "true"?true:false)));
      }
    }
    catch(err){console.log(err);}

  },[]);
 

  useEffect(() => {
    // if (isInitialRenderWithDependancy.current) {
    //   isInitialRenderWithDependancy.current = false;
    //   return;
    // }
    // if (isInitialRenderWithDependancy.current === false && isInitialRenderEmptyDependancy.current) {
    //   isInitialRenderEmptyDependancy.current = false;
    //   return;
    // }
    if(isComponentLoading)
    {
      setIsComponentLoading(false);
      return;
    }

    CancelTripFromARQPRQSRQ();

  }, [IsReturnTrip]);


  /////////////////////////////////////////////////////  CANCEL COMPONENT HOOKS ///////////////////////////////////////////////////////
   
  /////////////////////////////////////////////////////  STATE UPDATE ENGINE SWITCH ///////////////////////////////////////////////////
  const updateCancelTripComponentStateObjects = (stateObj, newValues) => {
    switch (stateObj) {
      case "cancelTripObj":
        setCancelTripObj((prevCancelTripObj) => ({
          ...prevCancelTripObj,
          ...newValues
        }));
        break;
      // case "confirmationModal":
      //   setConfirmationModal((prevconfirmationModal) => ({
      //     ...prevconfirmationModal,
      //     ...newValues
      //   }));
      //   break;  
      default:
        break;
    }
  };
 /////////////////////////////////////////////////////  STATE UPDATE ENGINE SWITCH ///////////////////////////////////////////////////

  function CancelTripFromARQPRQSRQ()
  {
    try{
      if (cancelTripObj.CreatedBy === "(ExternalDispatch)") {
        setCancelAlert({...cancelAlert, alertTitle: 'Trip cancel restricted', alertMsg:'This is a broker trip, cancel not allowed!'});
        setShowCancelAlert(true);
        return false;
      }
  
      if (cancelTripObj.TripRequestStatus.toLowerCase() === "pickedup") {
        setShowTripStatus(true);
      }
      if(String(IsReturnTrip).toLowerCase() === "true")
      {
        setchkReturnTripVisible(true);
        setIsReturnTripChecBox(true);
      }
      else
      {
        setchkReturnTripVisible(true);
        setIsReturnTripChecBox(false);
      }
  
      data.setShowCancel(true);
    }
    catch(err){console.log(err);}
    
    
    // if (forceCancel === false && cancelTripObj.TripRequestStatus.toLocaleLowerCase() === "pickedup") {
    //       updateCancelTripComponentStateObjects("confirmationModal", {...confirmationModal, 
    //       show: true, title: `Confirm Cancel : '${data.GridRowData.ConfirmationNo}'`,
    //       body: `Confirmation# '${data.GridRowData.ConfirmationNo}' and pickup person '${data.GridRowData.PickupPerson}', has already been marked as Picked-Up. Would you still like to mark it as Cancel?`,
    //       msgType:'pickeduptrip'});
    //       return;
    // }else{
    //   if (IsReturnTrip.toLocaleLowerCase() === "true") {
    //     updateCancelTripComponentStateObjects("confirmationModal", {...confirmationModal, btnOkText: 'Yes', btnCancelText: 'No',
    //       show: true, title: `Confirm Cancel : '${data.GridRowData.ConfirmationNo}'`,
    //       body: `Confirmation# '${data.GridRowData.ConfirmationNo}', and Pickup Person ' ${data.GridRowData.PickupPerson}', also has return leg(s).
    //       Please click 'YES' to cancel this trip along with all return legs?
    //       Click 'No' to cancel only selected trip.`,
    //       msgType:'isreturntrip'});
    //       return;
    //   }
    //   else
    //   {
    //     setShowCancelDialog(true);
    //   }
    // }
  }

  
  
  ////////////////////////////////////////////////////// CANCEL DIALOG EVENTS //////////////////////////////////////////////////

   //Loading cancel reason dropdown by affiliate 
   const LoadingCancelReasonByAffiliate = () => {
    try{
      if(data.GridRowData.length !== 0)
      {
        const cancelReasonJSON = (CancelReasonData[data.GridRowData[0].iSRATSPID] !==  undefined && data.GridRowData[0].iSRATSPID !== null)? JSON.parse(CancelReasonData[data.GridRowData[0].iSRATSPID]): undefined;
        if(cancelReasonJSON !== undefined && cancelReasonJSON !== null){
          const cancelReasonByAffiliate = [];
          cancelReasonByAffiliate.push({"name": "Select reason ...", "id": -1, "description": "" });
          cancelReasonJSON.map((item) => {
            return cancelReasonByAffiliate.push({"name": item.vTitle, "id": item.iId, "description": item.vDescription });
          })
          if(cancelReasonByAffiliate.length > 0)
          {
            setCancelReasons(cancelReasonByAffiliate);
          }
        }
        else if(data.GridRowData[0].TripRequestStatus.toUpperCase() === "CANCELLLED")
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Cancel Reasons', alertMsg:'Selected Trip is already cancelled!'});
          setShowCancelAlert(true);
          return false;
        }
        else{
          setCancelAlert({...cancelAlert, alertTitle: 'Cancel Reasons', alertMsg:'Cancel reason not loading!'});
          setShowCancelAlert(true);
          return false;
        }
      }
      
    }
    catch(err){console.log(err);}
    
  }

  const OpenCancelDialg = ()=> { 
    LoadingCancelReasonByAffiliate();
  }

  const handleReturnTripCheckBox = () => {
    setIsReturnTripChecBox(prevValue => !prevValue);
  }

  const handleCancelReasonChange = (e) => {
    const iTem = cancelReasons.find((item) => {
      return (item.id === Number(e.target.value)) 
    })
    if(iTem)
      cancelCommentRef.current.value = iTem.description;
  }

  const handleCancelDialogOK = async() => {
    
    // if(false)
    // {
    //   setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'Trip already Dispatched! Trip not available to cancel.'});
    //   setShowCancelAlert(true);
    //   return false;
    // }
    // console.log(data.GridRowData);
    try{
      if(data.GridRowData.length > 1)
      {
        
        let tempArr = [];
        let confirmationFlag = false;
        for(let y in TripSelection)
        {
          tempArr.push(Object.values(TripSelection[y])[0]);
        }
        
        if(tempArr.indexOf(1) > -1)
        {
          let Queue = "";
          for(let k = 0; k < data.GridRowData.length; k++)
          {
            if(TripSelection[k][data.GridRowData[k].ConfirmationNo] === 1)
            {
              if ((data.GridRowData[k].TripRequestStatus.toLowerCase() === "accepted" || data.GridRowData[k].TripRequestStatus.toLowerCase() === "dispatched" 
                || data.GridRowData[k].TripRequestStatus.toLowerCase() === "irtpu" || data.GridRowData[k].TripRequestStatus.toLowerCase() === "atlocation" 
                || data.GridRowData[k].TripRequestStatus.toLowerCase() === "pickedup") && (data.GridRowData[k].TableSource !== "FromScheduleTable"))
                Queue = "InProgress";
              else if (data.GridRowData[k].TableSource === "FromScheduleTable")
                Queue = "Scheduled";
              else
                Queue = "OnDemand";
  
              let apiData = {
                iSRATSPID:String(data.GridRowData[k].iSRATSPID), ServiceID:String(data.GridRowData[k].ServiceID),TripRequestStatus:data.GridRowData[k].TripRequestStatus, iAssignedVehicleId:
                (typeof data.GridRowData[k].iAssignedVehicleId === "undefined"||data.GridRowData[k].iAssignedVehicleId === null)?'-1':String(data.GridRowData[k].iAssignedVehicleId),
                iScheduleID:(typeof data.GridRowData[k].iScheduleID === "undefined"||data.GridRowData[k].iScheduleID === null)?'-1': String(data.GridRowData[k].iScheduleID),
                AssignedDriverId:(typeof data.GridRowData[k].AssignedDriverId === "undefined"||data.GridRowData[k].AssignedDriverId === null)?'-1':String(data.GridRowData[k].AssignedDriverId),
                ConfirmationNo:data.GridRowData[k].ConfirmationNo,PickupPerson:data.GridRowData[k].PickupPerson,PZONE:data.GridRowData[k].PZONE,
                IsReturnTrip:(String(data.GridRowData[k].IsReturnTrip).toLowerCase()==="true"?true:false),TableSource:data.GridRowData[k].TableSource, 
                ServiceStatus: data.GridRowData[k].ServiceStatus, iSchDetailID:(typeof data.GridRowData[k].iSchDetailID === "undefined" || data.GridRowData[k].iSchDetailID === null)?'-1':data.GridRowData[k].iSchDetailID,
                CancelTripConf: data.GridRowData[k].ConfirmationNo, CancelTripPickPerson:data.GridRowData[k].PickupPerson, Queue:Queue, iCancelID:cancelReasonRef.current.value, 
                vCancelComments: cancelCommentRef.current.value, iUserID:loginData.iUserID, iAppID:"26"
              };
              let response = await APICom.fetchData("", "TripActions/PerformCancel", "post", { "Content-Type": "application/json" }, apiData, null);
              if(response.data.rowcount <= 0)
              {
                setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'Trip cancellation failed.'});
                setShowCancelAlert(true);
                confirmationFlag = false;
                break;
              }
              else
              {
                confirmationFlag = true;
              }
            }
          } 
          if(confirmationFlag)
          {
            setCancelAlert({...cancelAlert, alertTitle: 'Action Successful', alertMsg:'Trips cancelled successfully.'});
            setShowCancelAlert(true);
            return false;
          }
          
        }
        else
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'No Trips were selected, please select a trip and try again.'});
          setShowCancelAlert(true);
          return false;
        }
         
      }
      else if(data.GridRowData.length === 1)
      {
        let Queue = "";
        if ((cancelTripObj.TripRequestStatus.toLowerCase() === "accepted" || cancelTripObj.TripRequestStatus.toLowerCase() === "dispatched" || cancelTripObj.TripRequestStatus.toLowerCase() === "irtpu" || cancelTripObj.TripRequestStatus.toLowerCase() === "atlocation" || cancelTripObj.TripRequestStatus.toLowerCase() === "pickedup") && (cancelTripObj.TableSource !== "FromScheduleTable"))
          Queue = "InProgress";
        else if (cancelTripObj.TableSource === "FromScheduleTable")
          Queue = "Scheduled";
        else
          Queue = "OnDemand";
  
        cancelTripObj.IsReturnTrip = (chkReturnTripRef.current === undefined) ? false: chkReturnTripRef.current.checked;
        cancelTripObj["iCancelID"] = cancelReasonRef.current.value;
        cancelTripObj["vCancelComments"] = cancelCommentRef.current.value;
        cancelTripObj["iUserID"] = loginData.iUserID;
        cancelTripObj["Queue"] = Queue;
        cancelTripObj["iAppID"] = "26";
        let response = await APICom.fetchData("", "TripActions/PerformCancel", "post", { "Content-Type": "application/json" }, cancelTripObj, null);
        let result = response.data;
        if(Number(result.rowcount) > 0)
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action Successful', alertMsg:'Trip cancelled successfully.'});
          setShowCancelAlert(true);
          return false;
        }
        else
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action failed', alertMsg:'Trip cancellation failed.'});
          setShowCancelAlert(true);
          return false;
        }
      }
      
    }
    catch(err){console.log(err);}
    
  };

  const handleCancelDialogClose = () => {
    data.setShowCancel(false);
    // UnMountCancelTripComponent();
  };

const handleFilteringConfirmNum = (e)=>{
  try{
    let elements = document.getElementsByClassName('TripsInfoList');
    
    for(var k = 0; k < elements.length; k++)
    {
        if(!elements[k].children[1].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[k].style.display = "none";
        }
        else
        {
          elements[k].style.display = "table-row";
        }
    }
  }
  catch(err){console.log(err);}
};

const handleFilteringPUPerson = (e)=>{
  try{
    let elements = document.getElementsByClassName('TripsInfoList');

    for(var k = 0; k < elements.length; k++)
    {
        if(!elements[k].children[2].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[k].style.display = "none";
        }
        else
        {
          elements[k].style.display = "table-row";
        }
    }
  }
  catch(err){console.log(err);}
  
};

const handleSelectionChange = (index, confirmation, selection)=>{
  try{
    setTripSelection(prevState=>{
      const newState = {...prevState};
      newState[index][confirmation] = selection === true?1:0;
      return newState;
    });
  }
  catch(err){console.log(err);}
};
  ////////////////////////////////////////////////////// CANCEL DIALOG EVENTS /////////////////////////////////////////////////

 ////////////////////////////////////////////////////// CONFIRMATION DIALOG EVENTS /////////////////////////////////////////////
  // const handleConfirmationModelOpen = () => { }

  // const handleConfirmationModalOK = () => {
  //   let msgType = confirmationModal.msgType;
  //   switch (msgType) {
  //     case "pickeduptrip":
  //       // updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       // setForceCancel(true);
  //       break;
  //     case "isreturntrip":
  //       updateCancelTripComponentStateObjects("cancelTripObj", { ...cancelTripObj, IsReturnTrip:"true"});
  //       updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       setShowCancelDialog(true);
  //       break;  
  //     default:
  //       break;
  //   }
  // }

  // const handleConfirmationModalCancel = () =>{
  //   let msgType = confirmationModal.msgType;
  //   switch (msgType) {
  //     case "isreturntrip":
  //       updateCancelTripComponentStateObjects("cancelTripObj", { ...cancelTripObj, IsReturnTrip:"false"});
  //       updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       setShowCancelDialog(true);
  //       break;  
  //     default:
  //       setConfirmationModal({...confirmationModal, show:false})
  //       UnMountCancelTripComponent();
  //       break;
  //   }
   
  // }

  ////////////////////////////////////////////////////// CONFIRMATION DIALOG EVENTS /////////////////////////////////////////////
  const handleAlertModalClose = () => {
    setShowCancelAlert(false);
    UnMountCancelTripComponent();
  }
  ////////////////////////////////////////////////////// UnMount Cancel Component ///////////////////////////////////////////////
  const UnMountCancelTripComponent = () => {
    if(data.showCancel)
      {
        data.setShowCancel(false);
        console.log("Cancel component Unmounted!");
      }
  }
  ////////////////////////////////////////////////////// UnMount Cancel Component ///////////////////////////////////////////////

    return (
       <>

        {data.showCancel && <Modal size="lg" centered show={data.showCancel} onHide={handleCancelDialogClose} onShow={OpenCancelDialg} keyboard={true} backdrop="static" animation={true}>
        <Modal.Header  className='cancel_dialog_header_bgcolor mb-0' closeButton>
          <Modal.Title className='cancel_dialog_title_color user-select-none'>Cancel Reason</Modal.Title>
            </Modal.Header>
            <Modal.Body className='user-select-none'>
              <Container>
                
                  {showTripTable ? 
                    <Row className='overflow-auto' style={{height:"150px"}}>
                      <Col className="justify-content-center">
                        <table className="w-100 border border-dark">
                          <thead>
                              <tr className="text-center text-nowrap">
                                  {TableHeaders.map((head, headID) =>{
                                      if(head === "Confirmation#")
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="Confirmation#" onKeyUp={handleFilteringConfirmNum} className="d-block w-100 text-center"/></th>;
                                      }
                                      else if(head === "Pickup Person")
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="Name" onKeyUp={handleFilteringPUPerson} className="d-block w-100 text-center"/></th>;
                                      }
                                      else
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}</th>;
                                      }
                                  })}
                              </tr>
                          </thead>
                          <tbody>
                              {tripsInfo.map((item, index)=>(
                                  <tr key={index} className="text-center TripsInfoList">
                                    <td className="border border-dark user-select-none"><input checked={TripSelection[index][item.ConfirmationNo]=== 1} onChange={(e)=>handleSelectionChange(index, item.ConfirmationNo, e.target.checked)} style={{cursor:"pointer"}} value={index} type="checkbox"/></td>
                                    <td value={item.ConfirmationNo} className="border border-dark user-select-none">{item.ConfirmationNo}</td>
                                    <td value={item.PickupPerson} className="border border-dark user-select-none">{item.PickupPerson}</td>
                                    <td value={item.TripRequestStatus} className="border border-dark user-select-none">{item.TripRequestStatus}</td>
                                    <td value={item.IsReturnTrip} className="border border-dark user-select-none"><input checked={String(item.IsReturnTrip).toLowerCase() === "true"} disabled={true} style={{cursor:"not-allowed"}} type="checkbox"/></td>
                                  </tr>
                              ))}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  :
                  <Row>
                    <Col xs={6} md={3}>
                      <b>Confirmation#: </b>{cancelTripObj.CancelTripConf}
                    </Col>
                    <Col xs={6} md={5}>
                      <b>Pickup Person: </b>{cancelTripObj.CancelTripPickPerson}
                    </Col>
                    <Col xs={6} md={4}>
                      <b>{chkReturnTripVisible && <Form.Check type="checkbox" id="chkReturnTrips" label={"Cancel with return leg(s)"} checked={isReturnTripCheckBox} ref={chkReturnTripRef} onChange={handleReturnTripCheckBox} className='cancel_dialog_returncheckbox_color' />}</b>
                    </Col>
                  </Row>
                  }
                
                <Row>
                  <Col xs={6} md={6}>
                  {showTripStatus && <Form.Label><b>Status:<span className='cancel_dialog_tripStatus_color'>&nbsp; is {cancelTripObj.TripRequestStatus}, Still want to Cancel?</span></b></Form.Label>}
                  </Col>
                  <Col xs={6} md={2}>
                      &nbsp;
                  </Col>
                  <Col xs={6} md={4}>
                      &nbsp;
                  </Col>
                </Row>
              </Container>
              <Form>
              
                <Form.Group className="mb-2 cancel_dialog_reason_indent" controlId="exampleForm.ControlInput1">
                  <Form.Label><b>Reason</b></Form.Label>
                  <Form.Select aria-label="Default select example" onChange={handleCancelReasonChange} ref={cancelReasonRef}>
                    {cancelReasons.map(({ id, name }, index) => <option key={id} value={id} >{name}</option>)} 
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-0 cancel_dialog_reason_indent" controlId="exampleForm.ControlTextarea1">
                  <Form.Label><b>Any Comments</b></Form.Label>
                  <Form.Control as="textarea" rows={2} ref={cancelCommentRef} />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button className='cancel_btn_ok' onClick={handleCancelDialogOK}>
                OK
              </Button>
              <Button variant="secondary" onClick={handleCancelDialogClose}>
                Cancel
              </Button>
            </Modal.Footer>
      </Modal> }

       { showCancelAlert && <Modal backdrop="static" centered show={showCancelAlert} onHide={handleAlertModalClose} animation={true}>
        <Modal.Header className='cancel_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
          <Modal.Title className='cancel_dialog_title_color'>{cancelAlert.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{cancelAlert.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAlertModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>}
      {/* {confirmationModal.show? <ConfirmationModal options={confirmationModal} onOpen={handleConfirmationModelOpen} onCancel={handleConfirmationModalCancel} onOk={handleConfirmationModalOK}  /> : ""} */}
      </>
       
      );
};


export default CancelTrip;